

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'avoid',
      dataIndex: 'avoid',
      title: '需回避博物馆',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '用户ID',
    },
    {
      key: 'realname',
      dataIndex: 'realname',
      title: '姓名',
    },

    {
      key: 'mobile',
      dataIndex: 'mobile',
      title: '手机号',
    },
    {
      key: 'egname',
      dataIndex: 'egname',
      title: '博物馆专家组',
    },
    {
      key: 'operate1',
      dataIndex: 'operate1',
      title: '编辑',

      width: 100,
      slot: 'operate1',
    },
    {
      key: 'operate',
      dataIndex: 'operate',
      title: '删除',
      width: 100,
      slot: 'operate',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
